'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isLastWeek;


// WEBPACK FOOTER //
// ./~/sugar-date/date/isLastWeek.js